import { render, staticRenderFns } from "./ConfirmarEmail.vue?vue&type=template&id=09dc23ac"
import script from "./ConfirmarEmail.vue?vue&type=script&lang=ts"
export * from "./ConfirmarEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports